import Lenis from 'lenis'
import gsap from 'gsap'
import { initPortafolio3D } from './portafolio3d.js'

const movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches
const esMovil = window.matchMedia('(max-width: 1024px)').matches // móvil + tablet
const esClaro = window.matchMedia('(prefers-color-scheme: light)').matches // Home en modo claro ("galería")

/**
 * Entry de Vite. Empaqueta este archivo (+ portafolio3d.js + three/gsap/lenis)
 * en build/js/portafolio3d.js, que el PHP incluye con <script type="module">.
 */

/**
 * REVEAL del contenido (desacoplado del 3D: aparece aunque el WebGL falle).
 * Oculta el contenido de cada sección (menos el hero) y lo revela al entrar en
 * viewport con IntersectionObserver (eficiente y funciona con o sin Lenis).
 */
if (!movimientoReducido) {
    const secciones = [...document.querySelectorAll('.section')]

    // Ocultar desde la carga (están bajo el fold: nunca se ven "prendidas" → sin parpadeo).
    secciones.forEach((sec, i) => {
        if (i === 0) return // el hero lo revela la entrada cinematográfica
        const contenido = sec.querySelector('.section__contenido')
        if (contenido) gsap.set(contenido, { opacity: 0, y: 50 })
    })

    const io = new IntersectionObserver(
        (entradas) => {
            entradas.forEach((e) => {
                if (!e.isIntersecting) return
                const contenido = e.target.querySelector('.section__contenido')
                if (contenido) gsap.to(contenido, { opacity: 1, y: 0, duration: 1.1, ease: 'power3.out' })
                io.unobserve(e.target) // una sola vez
            })
        },
        { threshold: 0.6 }, // revela cuando ya estás bien dentro de la sección
    )
    secciones.forEach((sec, i) => { if (i > 0) io.observe(sec) })

    /**
     * Scroll suave (Lenis) + snap: SOLO en escritorio. En táctil el scroll nativo
     * con momentum es mejor y más ligero; Lenis/snap se sienten raros con el dedo.
     */
    if (!esMovil) {
        const lenis = new Lenis({ lerp: 0.08 })
        gsap.ticker.add((time) => lenis.raf(time * 1000))
        gsap.ticker.lagSmoothing(0)

        let snapTimeout = null
        const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)

        lenis.on('scroll', ({ scroll }) => {
            const h = window.innerHeight
            // Snap suave: tras ~150ms sin scroll, asienta en la sección más cercana.
            clearTimeout(snapTimeout)
            snapTimeout = setTimeout(() => {
                const objetivo = Math.round(lenis.scroll / h) * h
                if (Math.abs(lenis.scroll - objetivo) > 4) {
                    lenis.scrollTo(objetivo, { duration: 1, easing: easeOutCubic })
                }
            }, 150)
        })
    }
}

initPortafolio3D({
    canvas: document.querySelector('canvas.webgl'),

    // Sistema de diseño. En modo claro el Home pasa a "galería" (fondo claro).
    colorFondo: esClaro ? '#F4F2EE' : '#0A0A0F',
    colorDefecto: '#F2F2F7',
    colorParticulas: esClaro ? '#3A3A44' : null, // claro: polvo oscuro; oscuro: estrellas claras (default)
    colorAcento: esClaro ? '#E01E72' : '#FF2E88', // ~10% de partículas en magenta: chispas de marca (sutil, no satura)
    proporcionAcento: 0.1,
    sombraModelos: esClaro,            // claro: sombra suave detrás de cada modelo (aterriza + separa)

    // Assets 3D
    rutaModelos: '/assets/models/',
    rutaFuente: '/assets/fonts/helvetiker_regular.typeface.json',
    rutaGradiente: '/assets/textures/gradients/3.jpg',

    // Aligerado en móvil/tablet (sin esto, el 3D ahoga la GPU del dispositivo):
    usarBloom: !esMovil && !esClaro,   // bloom solo en escritorio OSCURO (en claro se apaga)
    // Pixel ratio: móvil a 2 → nítido en pantallas retina (la escena móvil es
    // ligera: sin bloom, modelos pequeños). Desktop 1.5: recorta la memoria de
    // los render targets del bloom → evita que la GPU resetee el contexto.
    pixelRatioMax: esMovil ? 2 : 1.5,
    // En claro las partículas son "polvo" oscuro: más y un poco más grandes para
    // que se perciban sobre el fondo claro.
    cantidadParticulas: esClaro ? 320 : (esMovil ? 130 : 200),
    tamañoParticulas:   esClaro ? 0.045 : (esMovil ? 0.07 : 0.03),
    // Brillo: el claro (sin bloom) sube reflejos para que el metal "pope"; el
    // móvil oscuro (sin bloom) sube exposición. Escritorio oscuro = base.
    exposicion:        esClaro ? 1.1 : (esMovil ? 2.0 : 1.0),
    intensidadLuz:     esClaro ? 1.2 : (esMovil ? 1.8 : 1),
    intensidadEntorno: esClaro ? 0.6  : (esMovil ? 0.55 : 0.35),
    escalaFactor: esMovil ? 0.5 : 1,   // modelos más chicos en móvil (que no se desborden)
    apilado: esMovil,                  // móvil: modelo centrado y abajo (texto arriba)
    movil: esMovil,                    // móvil: carga los modelos ultra-ligeros (data-src-movil)
    separacionModelo: esMovil ? 0 : 1.3,

    debug: false,
})
